module.exports = __webpack_public_path__ + "static/img/1958_08_14_AnticMeet_Program_6.0ce7464.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1958_08_14_AnticMeet_Program_6.jpg
// module id = srEv
// module chunks = 0